import { IUserLight } from "@core-lib/models";

export function fullName(user: IUserLight): string {
	return user?.prenom?.length > 0 ? user?.prenom[0] + '.' + user?.nom : user?.nom;
}